import * as React from 'react';
import { SvgComponentProps, Svg } from './svg-component';

export const InformationIcon = ({ size, ...rest }: SvgComponentProps) => (
    <Svg width={size || 48} height={size || 48} viewBox="0 0 48 48" fill="none" {...rest}>
        <path
            d="M28.5 33H27a3 3 0 0 1-3-3v-7.5a1.5 1.5 0 0 0-1.5-1.5H21"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M23.25 13.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M1.5 24a22.5 22.5 0 1 0 45 0 22.5 22.5 0 0 0-45 0v0Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Svg>
);
